@import '@hevoio/hevo-ui-toolkit/styles/variables';

// Same layout as the source-type picker: a definite centre track holding the
// tile grid, which centres it on the search axis without a max-width or an auto
// margin. The track has to stay definite — TileGrid sizes itself from its
// parent's offsetWidth, so it can never be what gives its own container a width.
.typeListWrapper {
  display: grid;
  grid-template-columns: 1fr var(--dest-tiles-width) 1fr;
  margin-top: $spacer-40;
  padding-bottom: 65px;
}

.tilesColumn {
  grid-column: 2;
}
